import { Document, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import {
  formatAmount,
  formatDate,
  stringToUpperCase,
} from "../../../../components/Helper";
import { SelfDocuments } from "../../../../components/Enums";

export const styles = StyleSheet.create({
  page: {
    paddingHorizontal: 30,
    paddingVertical: 15,
    fontFamily: "HostGrotesk",
    backgroundColor: "white",
  },
  fullpage: {
    margin: 7,
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#000000",
  },
  heading: {
    textAlign: "center",
  },
  sideBySideContainer: {
    display: "flex",
    flexDirection: "row",
  },
  shipper: {
    width: "60%",
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderRightWidth: 1,
    minHeight: "65px",
    padding: 4,
  },
  consignee: {
    width: "60%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    minHeight: "95px",
    padding: 4,
  },
  notify: {
    width: "60%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    minHeight: "95px",
    padding: 4,
  },
  notify2: {
    width: "40%",
    borderBottomWidth: 1,
    minHeight: "95px",
    padding: 4,
  },
  largeText: {
    fontSize: 7,
  },
  boldText: {
    fontWeight: "bold",
    fontSize: 10,
  },
  bookingNo: {
    borderTopWidth: 1,
    width: "40%",
    borderBottomWidth: 1,
    height: "65px",
  },
  empty: {
    borderBottomWidth: 1,
    width: "40%",
  },
  placeOfReceipt: {
    width: "27%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "32px",
  },
  vessel: {
    width: "33%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "32px",
  },
  portOfLoading: {
    width: "27%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "32px",
  },
  portOfDischarge: {
    width: "33%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "32px",
  },
  finalDestination: {
    width: "23%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "32px",
  },
  empty4: {
    borderBottomWidth: 1,
    width: "17%",
    textAlign: "center",
  },
  marksAndNumbers: {
    width: "27%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "20px",
    textAlign: "center",
  },
  descriptionOfGoods: {
    width: "46%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    textAlign: "center",
    height: "20px",
  },
  weight: {
    width: "10%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "20px",
    textAlign: "center",
  },
  marksAndNumbers2: {
    width: "27%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    minHeight: "150px",
  },
  descriptionOfGoods2: {
    width: "46%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    minHeight: "150px",
    padding: 4,
  },
  weight2: {
    width: "10%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    minHeight: "150px",
  },
  measurement: {
    borderBottomWidth: 1,
    width: "17%",
    minHeight: "150px",
  },
  srno: {
    width: "10%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "15px",
    textAlign: "center",
  },
  container: {
    width: "17%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "15px",
    textAlign: "center",
  },
  lineSeal: {
    width: "14%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "15px",
    textAlign: "center",
  },
  pkgs: {
    width: "8%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "15px",
    textAlign: "center",
  },
  grossWt: {
    width: "12%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "15px",
    textAlign: "center",
  },
  netWt: {
    width: "12%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "15px",
    textAlign: "center",
  },
  size: {
    width: "10%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "15px",
    textAlign: "center",
  },
  empty5: {
    borderBottomWidth: 1,
    width: "17%",
    height: "15px",
    textAlign: "center",
  },
  weightData: {
    height: "70px",
    textAlign: "center",
    borderBottomWidth: 1,
  },
  weightData2: {
    height: "30px",
    textAlign: "center",
    borderBottomWidth: 1,
  },
  weightData3: {
    height: "30px",
    textAlign: "center",
  },
});

const BlDraftInvoice = ({
  settingData,
  salesInvoiceData,
}: {
  settingData: any;
  salesInvoiceData: any;
}) => {
  const calculateTotal = (items: any, keyName: string) => {
    let total = 0;
    items?.forEach((item: any) => {
      total += Number(item[keyName]);
    });
    return total;
  };

  const notifyParty = salesInvoiceData?.is_notify_party
    ? salesInvoiceData?.notify_party
    : salesInvoiceData?.buyer;

  let portOfLoading = "-";
  if (
    salesInvoiceData?.origin_port?.name &&
    salesInvoiceData?.origin_port?.country
  ) {
    portOfLoading = `${stringToUpperCase(
      salesInvoiceData?.origin_port?.name,
    )}, ${stringToUpperCase(salesInvoiceData?.origin_port?.country)}`;
  } else if (
    salesInvoiceData?.origin_port?.name &&
    !salesInvoiceData?.origin_port?.country
  ) {
    portOfLoading = `${stringToUpperCase(salesInvoiceData?.origin_port?.name)}`;
  } else if (
    !salesInvoiceData?.origin_port?.name &&
    salesInvoiceData?.origin_port?.country
  ) {
    portOfLoading = `${stringToUpperCase(
      salesInvoiceData?.origin_port?.country,
    )}`;
  }

  const documentInputFields =
    salesInvoiceData?.my_documents_inputs?.[SelfDocuments.BILL_OF_LADING];

  return (
    <Document>
      <Page style={styles.page} size="A4">
        <View style={styles.fullpage}>
          <Text style={[styles.heading]}>BL DRAFT</Text>

          {/* Shipper & Booking no */}
          <View style={[styles.sideBySideContainer]}>
            <View style={[styles.shipper]}>
              <Text style={[styles.boldText]}>SHIPPER :</Text>
              <Text style={[styles.largeText]}>
                {stringToUpperCase(settingData?.company_name)}
              </Text>
              <Text style={[styles.largeText]}>
                {stringToUpperCase(settingData?.company_address?.slice(0, 13))}
              </Text>
              <Text style={[styles.largeText]}>
                {stringToUpperCase(settingData?.company_address?.slice(14, 37))}
              </Text>
              <Text style={[styles.largeText]}>
                {stringToUpperCase(settingData?.company_address?.slice(40))}
              </Text>
              {/* <Text style={[styles.largeText,{ left: 5, top: 3 }]}>
                GSTIN: {stringToUpperCase(settingData?.company_gst_no)}
              </Text>
              <Text style={[styles.largeText,{ left: 5, top: 3 }]}>
                PAN NO: {stringToUpperCase(settingData?.company_pan_no)}
              </Text>
              <Text style={[styles.largeText,{ left: 5, top: 3 }]}>
                AEO REG. NO:{" "}
                {stringToUpperCase(settingData?.aeo_registration_no)}
              </Text> */}
            </View>
            <View style={[styles.bookingNo]}>
              <Text style={[styles.boldText]}>BOOKING NO.</Text>
              <Text style={[styles.largeText]}>
                {stringToUpperCase(documentInputFields?.booking_no)}
              </Text>
              <Text style={[styles.largeText]}>
                LINE : {stringToUpperCase(documentInputFields?.line)}
              </Text>
            </View>
          </View>

          {/* Consignee */}
          <View style={[styles.sideBySideContainer]}>
            <View style={[styles.consignee]}>
              <Text style={[styles.boldText]}>CONSIGNEE :</Text>
              <Text style={[styles.largeText]}>
                {stringToUpperCase(salesInvoiceData?.buyer?.name)}{" "}
              </Text>
              <Text style={[styles.largeText]}>
                {stringToUpperCase(salesInvoiceData?.buyer?.address)}
              </Text>
              <Text style={[styles.largeText]}>
                {stringToUpperCase(salesInvoiceData?.buyer?.phone_no)}
              </Text>
              <Text style={[styles.largeText]}>
                {stringToUpperCase(salesInvoiceData?.buyer?.email)}
              </Text>
              <Text style={[styles.largeText]}>
                TAX ID: {stringToUpperCase(salesInvoiceData?.buyer?.tax_id)}
              </Text>
              <Text style={[styles.largeText]}>
                CONTACT NAME:{" "}
                {stringToUpperCase(salesInvoiceData?.buyer?.buyer_name)}
              </Text>
            </View>
            <View style={[styles.empty]}></View>
          </View>

          {/* Notify */}
          <View style={[styles.sideBySideContainer]}>
            <View style={[styles.notify]}>
              <Text style={[styles.boldText]}>NOTIFY :</Text>
              <Text style={[styles.largeText]}>
                {stringToUpperCase(notifyParty.name)}{" "}
              </Text>
              <Text style={[styles.largeText]}>
                {stringToUpperCase(notifyParty.address)}
              </Text>
              <Text style={[styles.largeText]}>
                {stringToUpperCase(notifyParty.phone_no)}
              </Text>
              <Text style={[styles.largeText]}>
                {stringToUpperCase(notifyParty.email)}
              </Text>
              <Text style={[styles.largeText]}>
                TAX ID: {stringToUpperCase(notifyParty?.tax_id)}
              </Text>
              <Text style={[styles.largeText]}>
                CONTACT NAME:{" "}
                {salesInvoiceData?.is_notify_party
                  ? stringToUpperCase(notifyParty?.notify_party_name)
                  : stringToUpperCase(salesInvoiceData?.buyer?.buyer_name)}
              </Text>
            </View>
            <View style={[styles.notify2]}>
              <Text style={[styles.boldText]}>NOTIFY 2 :</Text>
            </View>
          </View>

          {/* Place of receipt & vessel */}
          <View style={[styles.sideBySideContainer]}>
            <View style={[styles.placeOfReceipt]}>
              <Text style={[styles.boldText, { left: 5, top: 2 }]}>
                PLACE OF RECEIPT :
              </Text>
              <Text style={[styles.largeText, { left: 5, top: 2 }]}>
                {portOfLoading}
              </Text>
            </View>
            <View style={[styles.vessel]}>
              <Text style={[styles.boldText, { left: 5, top: 2 }]}>
                VESSEL :
              </Text>
              <Text style={[styles.largeText, { left: 5, top: 2 }]}>
                {salesInvoiceData.vessel_no}
              </Text>
            </View>
            <View style={[styles.empty]}></View>
          </View>

          {/* Port Of Loading & Discharge */}
          <View style={[styles.sideBySideContainer]}>
            <View style={[styles.portOfLoading]}>
              <Text style={[styles.boldText, { left: 5, top: 2 }]}>
                PORT OF LOADING :
              </Text>
              <Text style={[styles.largeText, { left: 5, top: 2 }]}>
                {portOfLoading}
              </Text>
            </View>
            <View style={[styles.portOfDischarge]}>
              <Text style={[styles.boldText, { left: 5, top: 2 }]}>
                PORT OF DISCHARGE :
              </Text>
              <Text style={[styles.largeText, { left: 5, top: 2 }]}>
                {salesInvoiceData?.destination_port
                  ? stringToUpperCase(salesInvoiceData?.destination_port)
                  : "-"}
              </Text>
            </View>
            <View style={[styles.finalDestination]}>
              <Text style={[styles.boldText, { left: 5, top: 2 }]}>
                FINAL DESTINATION :
              </Text>
              <Text style={[styles.largeText, { left: 5, top: 2 }]}>
                {salesInvoiceData?.destination_port
                  ? stringToUpperCase(salesInvoiceData?.destination_port)
                  : "-"}
              </Text>
            </View>
            <View style={[styles.empty4]}></View>
          </View>

          {/* Description of goods section */}
          {/* Heading */}
          <View style={[styles.sideBySideContainer]}>
            <View style={[styles.marksAndNumbers]}>
              <Text style={[styles.boldText, { top: 2 }]}>MARKS & NUMBERS</Text>
            </View>
            <View style={[styles.descriptionOfGoods]}>
              <Text style={[styles.boldText, { top: 2 }]}>
                DESCRIPTION OF GOODS
              </Text>
            </View>
            <View style={[styles.weight]}>
              <Text style={[styles.boldText, { top: 2 }]}>WEIGHT</Text>
            </View>
            <View style={[styles.empty4]}>
              <Text style={[styles.boldText, { top: 2 }]}>MEASUREMENT</Text>
            </View>
          </View>
          {/* Data */}
          <View style={[styles.sideBySideContainer]}>
            <View style={[styles.marksAndNumbers2]}></View>
            <View style={[styles.descriptionOfGoods2]}>
              {salesInvoiceData?.sales_invoice_products?.map(
                (product: any, index: number) => (
                  <View key={index} wrap={false} style={{ marginBottom: 6 }}>
                    {/* ROW 1: Container */}
                    <Text style={[styles.largeText, { marginBottom: 2 }]}>
                      {`${stringToUpperCase(product?.container_load)} FCL CONTAINERS`}
                    </Text>

                    {/* ROW 2: Product Name + HSN */}
                    <Text style={[styles.largeText]}>
                      {stringToUpperCase(product?.product?.name)}{" "}
                      {product?.product?.hsn_no
                        ? `(HS CODE: ${stringToUpperCase(product?.product?.hsn_no)})`
                        : ""}
                    </Text>

                    {/* ROW 3: Bags + Packing */}
                    <Text style={[styles.largeText, { marginBottom: 2 }]}>
                      {`${product?.no_of_bags || "-"} BAGS (PACKED IN ${
                        product?.packing_type?.name
                          ? stringToUpperCase(product?.packing_type?.name)
                          : "BAGS"
                      })${
                        product?.packing_net_weight
                          ? ` NET ${formatAmount(product?.packing_net_weight, 3)} KGS`
                          : ""
                      }${
                        product?.packing_gross_weight
                          ? ` & GROSS ${formatAmount(product?.packing_gross_weight, 3)} KGS EACH BAG`
                          : ""
                      }`}
                    </Text>
                  </View>
                ),
              )}

              {/* 🔽 COMMON DATA (ONLY ONCE) */}
              <View style={{ marginTop: 6 }}>
                <Text wrap={false} style={[styles.largeText]}>
                  INVOICE NO. {stringToUpperCase(salesInvoiceData.invoice_no)}
                </Text>

                <Text wrap={false} style={[styles.largeText]}>
                  SB NO.{" "}
                  {stringToUpperCase(documentInputFields?.sb_no) || "N/A"} DATE:{" "}
                  {formatDate(documentInputFields?.sb_date)}
                </Text>

                <Text wrap={false} style={[styles.largeText]}>
                  NET WT.{" "}
                  {formatAmount(salesInvoiceData?.total_net_weight / 1000, 3)}{" "}
                  MTS
                </Text>

                <Text wrap={false} style={[styles.largeText]}>
                  GROSS WT.{" "}
                  {formatAmount(salesInvoiceData?.total_gross_weight / 1000, 3)}{" "}
                  MTS
                </Text>

                <Text wrap={false} style={[styles.largeText]}>
                  14 DAYS FREE AT POD.
                </Text>
                <Text wrap={false} style={[styles.largeText]}>
                  FREIGHT PREPAID.
                </Text>
              </View>
            </View>
            <View style={[styles.weight2]}>
              <View style={[styles.weightData]}>
                <Text style={[styles.largeText, { top: 2 }]}>
                  TOTAL NET WT{" "}
                  {formatAmount(salesInvoiceData?.total_net_weight, 3)} KGS
                </Text>
              </View>
              <View style={[styles.weightData2]}></View>
              <View style={[styles.weightData]}>
                <Text style={[styles.largeText, { top: 2 }]}>
                  TOTAL GROSS WT{" "}
                  {formatAmount(salesInvoiceData?.total_gross_weight, 3)} KGS
                </Text>
              </View>
              <View style={[styles.weightData3]}></View>
            </View>
            <View style={[styles.measurement]}></View>
          </View>

          {/* Container table section*/}
          {/* Header */}
          <View wrap={false} style={[styles.sideBySideContainer]}>
            <View style={[styles.srno]}>
              <Text style={[styles.boldText]}>SR NO</Text>
            </View>
            <View style={[styles.container]}>
              <Text style={[styles.boldText]}>CONTAINER</Text>
            </View>
            <View style={[styles.lineSeal]}>
              <Text style={[styles.boldText]}>LINE SEAL</Text>
            </View>
            <View style={[styles.pkgs]}>
              <Text style={[styles.boldText]}>PKGS</Text>
            </View>
            <View style={[styles.grossWt]}>
              <Text style={[styles.boldText]}>GROSS WT</Text>
            </View>
            <View style={[styles.netWt]}>
              <Text style={[styles.boldText]}>NET WT</Text>
            </View>
            <View style={[styles.size]}>
              <Text style={[styles.boldText]}>SIZE</Text>
            </View>
            <View style={[styles.empty5]}>
              <Text style={[styles.boldText]}></Text>
            </View>
          </View>
          {/* Rows */}
          {salesInvoiceData?.containers?.length > 0 &&
            salesInvoiceData.containers.map((container: any, index: number) => (
              <View
                key={container.id || index}
                wrap={false}
                style={[styles.sideBySideContainer]}
              >
                <View style={[styles.srno]}>
                  <Text style={[styles.largeText, { top: 1 }]}>
                    {index + 1}
                  </Text>
                </View>
                <View style={[styles.container]}>
                  <Text style={[styles.largeText, { top: 1 }]}>
                    {stringToUpperCase(container?.container_no)}
                  </Text>
                </View>
                <View style={[styles.lineSeal]}>
                  <Text style={[styles.largeText, { top: 1 }]}>
                    {stringToUpperCase(container?.line_seal_no)}
                  </Text>
                </View>
                <View style={[styles.pkgs]}>
                  <Text style={[styles.largeText, { top: 1 }]}>
                    {container?.no_of_bags}
                  </Text>
                </View>
                <View style={[styles.grossWt]}>
                  <Text style={[styles.largeText, { top: 1 }]}>
                    {formatAmount(container?.total_gross_weight, 3)}
                  </Text>
                </View>
                <View style={[styles.netWt]}>
                  <Text style={[styles.largeText, { top: 1 }]}>
                    {formatAmount(container?.total_net_weight, 3)}
                  </Text>
                </View>
                <View style={[styles.size]}>
                  <Text style={[styles.largeText, { top: 1 }]}>
                    {container?.size
                      ? `${stringToUpperCase(container?.size)}'`
                      : ""}
                  </Text>
                </View>
                <View style={[styles.empty5]}>
                  <Text style={[styles.largeText, { top: 1 }]}></Text>
                </View>
              </View>
            ))}
          {/* Total Row */}
          <View style={[styles.sideBySideContainer]}>
            <View
              style={{
                width: "10%",
                borderRightWidth: 1,
                height: "15px",
                textAlign: "center",
              }}
            >
              <Text style={[styles.boldText]}></Text>
            </View>
            <View
              style={{
                width: "17%",
                borderRightWidth: 1,
                height: "15px",
                textAlign: "center",
              }}
            >
              <Text style={[styles.boldText]}> TOTAL </Text>
            </View>
            <View
              style={{
                width: "14%",
                borderRightWidth: 1,
                height: "15px",
                textAlign: "center",
              }}
            >
              <Text style={[styles.boldText]}></Text>
            </View>
            <View
              style={{
                width: "8%",
                borderRightWidth: 1,
                height: "15px",
                textAlign: "center",
              }}
            >
              <Text style={[styles.boldText]}>
                {calculateTotal(salesInvoiceData.containers, "no_of_bags")}
              </Text>
            </View>
            <View
              style={{
                width: "12%",
                borderRightWidth: 1,
                height: "15px",
                textAlign: "center",
              }}
            >
              <Text style={[styles.boldText]}>
                {formatAmount(
                  calculateTotal(
                    salesInvoiceData.containers,
                    "total_gross_weight",
                  ),
                  3,
                )}
              </Text>
            </View>
            <View
              style={{
                width: "12%",
                borderRightWidth: 1,
                height: "15px",
                textAlign: "center",
              }}
            >
              <Text style={[styles.boldText]}>
                {formatAmount(
                  calculateTotal(
                    salesInvoiceData.containers,
                    "total_net_weight",
                  ),
                  3,
                )}
              </Text>
            </View>
            <View
              style={{
                width: "10%",
                borderRightWidth: 1,
                height: "15px",
                textAlign: "center",
              }}
            >
              <Text style={[styles.boldText]}></Text>
            </View>
            <View
              style={{
                width: "17%",
                height: "15px",
                textAlign: "center",
              }}
            >
              <Text style={[styles.boldText]}></Text>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};
export default BlDraftInvoice;
